// extracted by mini-css-extract-plugin
export default {"wellsTree":"wells-selector_wellsTree__j6nmr","search":"wells-selector_search__lhk2G"};